"use client";

import { motion } from "framer-motion";
import Image from "next/image";
import Link from "next/link";
import { useEffect, useState } from "react";
import { buttons } from "@/styles/design-tokens";

export function Header() {
	const [isVisible, setIsVisible] = useState(true);
	const [prevScrollPos, setPrevScrollPos] = useState(0);

	useEffect(() => {
		const handleScroll = () => {
			const currentScrollPos = window.scrollY;
			setIsVisible(prevScrollPos > currentScrollPos || currentScrollPos < 10);
			setPrevScrollPos(currentScrollPos);
		};

		window.addEventListener("scroll", handleScroll);
		return () => window.removeEventListener("scroll", handleScroll);
	}, [prevScrollPos]);

	return (
		<motion.header
			className="w-full z-40 fixed top-8 left-0"
			initial={{ y: 0 }}
			animate={{ y: isVisible ? 0 : "-100%" }}
			transition={{ duration: 0.2 }}
		>
			<div className="py-4 max-w-screen-2xl mx-auto px-4 flex sm:justify-between items-center md:px-8 lg:px-16">
				<Link href="/">
					<Image
						src="/logo-desktop.svg"
						alt="Site Logo"
						width={608}
						height={48}
						className="hidden xl:block h-auto"
					/>
					<Image
						src="/logo-mobile.svg"
						alt="Site Logo"
						width={248}
						height={48}
						className="xl:hidden h-auto"
					/>
				</Link>

				{/* <TallyButton className={`${buttons.primarySmall} hidden sm:block`}>Start Your Project</TallyButton> */}
				<a
					href="https://calendly.com/hi-brianagude/30min"
					target="_blank"
					rel="noopener noreferrer"
					aria-label="Dianthe Studio Intro Call"
					className={`${buttons.primarySmall} hidden sm:block`}
				>
					{" "}
					Book an Intro Call
				</a>
			</div>
		</motion.header>
	);
}
